var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reinsurance-item"},[_c('div',{staticClass:"icon",style:('background-image:url(' + _vm.icon + ')')}),_c('div',{staticClass:"txt",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }